function Forecasting() {
  return <div><h2>Forecasting</h2><p>ML-based demand forecasting will go here.</p></div>;
}
export default Forecasting; 